export enum ChatType {
  EndChat,
  StartChat
}
